/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/_freeGlobal.js
// module id = 677
// module chunks = 0